module.exports = __webpack_public_path__ + "img/pic_160511.9de9628f.jpg";